import { loadCreativeDownloadUrl } from 'scenes/Gallery/GalleryPage/Creatives/sources/creatives';

export const useDownloadCreativeFileLink = () => {
  return async ({ id }) => {
    const { creativeUrl } = await loadCreativeDownloadUrl({ id });
    window.location.assign(creativeUrl);
  };
};
